export default __webpack_public_path__ + "static/media/dr.5da1bbd1.svg";